import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["printButton", "destroyButton", "signButton"];

  connect() {
    this.selectedCheckbox = 0;
    this.selectedDestroyCheckbox = [];
    this.blockedDestroyCheckbox = 0;

    this.selectedSign = [];
    this.blockedSign = 0;
  }

  readMode(){
    return JSON.parse(this.element.dataset.readMode)
  }

  togglePrintButton(event) {
    event.target.checked ? this.selectedCheckbox++ : this.selectedCheckbox--;

    if (JSON.parse(event.target.dataset.canDelete)) {
      event.target.checked
        ? this.selectedDestroyCheckbox.push(event.target.value)
        : (this.selectedDestroyCheckbox = this.selectedDestroyCheckbox.filter(
            id => id !== event.target.value
          ));
    } else {
      event.target.checked
        ? this.blockedDestroyCheckbox++
        : this.blockedDestroyCheckbox--;
    }

    this.handleSign(event.target)
    this.setDestroyUrl();

    this.selectedCheckbox > 0
      ? this.printButtonTarget.removeAttribute("disabled")
      : this.printButtonTarget.setAttribute("disabled", "");

    if (this.readMode()) {
      return false;
    }

    this.selectedDestroyCheckbox.length > 0 && this.blockedDestroyCheckbox === 0
      ? this.destroyButtonTarget.removeAttribute("disabled")
      : this.destroyButtonTarget.setAttribute("disabled", "");
  }

  handleSign(checkbox) {
    if (this.readMode()) {
      return false;
    }

    if (JSON.parse(checkbox.dataset.canSign)) {
      checkbox.checked
        ? this.selectedSign.push(checkbox.value)
        : (this.selectedSign = this.selectedSign.filter(
            id => id !== checkbox.value
          ));
    } else {
      checkbox.checked
        ? this.blockedSign++
        : this.blockedSign--;
    }

    this.setSignUrl();

    this.selectedSign.length > 0 && this.blockedSign === 0
      ? this.signButtonTarget.removeAttribute("disabled")
      : this.signButtonTarget.setAttribute("disabled", "");
  }

  setDestroyUrl() {
    if (this.selectedDestroyCheckbox.length === 0) {
      this.destroyButtonTarget.setAttribute("href", "#");
      return;
    }

    this.destroyButtonTarget.dataset.confirmSweet =
      this.selectedDestroyCheckbox.length === 1
        ? "Tem certeza que deseja apagar essa evolução?"
        : `Tem certeza que deseja apagar ${this.selectedDestroyCheckbox.length} evoluções?`;

    const url =
      this.destroyButtonTarget.dataset.url +
      "?" +
      this.selectedDestroyCheckbox
        .map(id => encodeURI(`ids[]=${id}`))
        .join("&");

    this.destroyButtonTarget.setAttribute("href", url);
  }

  setSignUrl() {
    if (this.selectedSign.length === 0) {
      this.signButtonTarget.setAttribute("href", "#");
      return;
    }

    const url =
      this.signButtonTarget.dataset.url +
      `?digital_signature[source]=evolution&${encodeURI('digital_signature[patient_id]')}=${this.signButtonTarget.dataset.patientId}&` +
      this.selectedSign
        .map(id => encodeURI(`digital_signature[evolution_ids][]=${id}`))
        .join("&");

    this.signButtonTarget.setAttribute("href", url);
  }
}
